import { useState } from 'react'
import { useSetRecoilState } from 'recoil'
import styled from 'styled-components'

import PurchasedItem from '~/features/mypage/PurchasedItem'
import { usePaymentList } from '~/features/mypage/queries/useMyInfo'
import Sii2 from '~/shared/assets/images/sii2.png'
import Button from '~/shared/components/buttons/Button'
import Pagination from '~/shared/components/pagination/Pagination'
import Tag from '~/shared/components/tags/Tag'
import { isModalOpenState, selectedRefundIdState } from '~/shared/states'
import theme from '~/shared/styles/theme'
import { fCurrency } from '~/shared/utils/format-number'

function PurchasedInfo() {
  const setIsModalOpen = useSetRecoilState(isModalOpenState)
  const setSelectedRefundId = useSetRecoilState(selectedRefundIdState)
  const [page, setPage] = useState(1)
  const { data: paymentList } = usePaymentList(page)

  const changePage = (event: any) => {
    if (paymentList && page <= paymentList?.data.pageInfo.max_page) {
      setPage(Number(event.target.innerText))
    }
  }

  const refundPayment = (id: number) => {
    setSelectedRefundId(id)
    setIsModalOpen({
      contents: 'payment-cancel',
      isOpen: true,
    })
  }

  return (
    <>
      {paymentList &&
      paymentList.data &&
      paymentList.data.user_payment_list.length > 0 ? (
        <>
          <InfoBox>
            <Title>결제 내역</Title>

            {paymentList.data.user_payment_list.map((payment) => (
              <PurchasedItem key={payment.id} data={payment}>
                <>
                  {payment.can_cancle ? (
                    <Button
                      $width={141}
                      $height={58}
                      $fontSize={18}
                      $variant="white"
                      onClick={() => refundPayment(payment.id)}
                    >
                      결제 취소
                    </Button>
                  ) : null}
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      구매 상품
                    </Tag>
                    <div className="desc">{payment.divide_desc}</div>
                  </TagBox>
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      결제 금액
                    </Tag>
                    <div className="desc">
                      {fCurrency(payment.total_amount)}
                    </div>
                  </TagBox>
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      결제 일시
                    </Tag>
                    <div className="desc">{payment.approved_at}</div>
                  </TagBox>
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      결제 수단
                    </Tag>
                    <div className="desc">{payment.payment_method}</div>
                  </TagBox>
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      승인 번호
                    </Tag>
                    <div className="desc">{payment.approve_no || '-'}</div>
                  </TagBox>
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      결제 상태
                    </Tag>
                    <div className="desc">{payment.status_desc || '-'}</div>
                  </TagBox>
                  <TagBox>
                    <Tag $size="sm" $variant="gray">
                      티켓 매수
                    </Tag>
                    <div className="desc">{`${payment.quantity}매` || '-'}</div>
                  </TagBox>
                </>
              </PurchasedItem>
            ))}
          </InfoBox>

          <Pagination
            page={page}
            count={paymentList.data.pageInfo.max_page}
            onChange={changePage}
          />
        </>
      ) : (
        <>
          <SiiImage src={Sii2} alt="sii2" />
          <Description>결제 내역이 없습니다.</Description>
        </>
      )}
    </>
  )
}

export default PurchasedInfo

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-between;

  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 36px 24px;

  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.grey_3};
  border-radius: 12px;

  button {
    width: 100%;
  }

  > div {
    display: flex;
    flex-direction: row;
    gap: 20px;

    @media ${theme.device.medium} {
      width: 100%;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    width: 100%;
  }
`

const Title = styled.h2`
  margin-bottom: 36px;
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 700;
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;
  width: 100%;

  .desc {
    width: 100%;
    font-family: NanumSquareNeo-Regular, sans-serif;
  }

  .thumbnail {
    width: 132px;
    height: 132px;
    border-radius: 12px;
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`

const SiiImage = styled.img`
  width: 580px;
  margin: 0 auto;

  @media ${theme.device.medium} {
    width: 100%;
  }
`

const Description = styled.div`
  margin: 0 auto;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 36px;
  font-weight: 500;
  line-height: 58.8px;

  @media ${theme.device.medium} {
    font-size: 24px;
    text-align: center;
  }
`
